import { LIST_ELEMENTS } from '../constants/editable-elements';

const CYRILLIC_NUMBERED_LIST_TRIGGERS = ['а.']; // There are only cyrillic symbols in this array

export const BULLET_LIST_TRIGGERS = ['-', '*'];
export const NUMBERED_LIST_TRIGGERS = ['1.', 'i.', 'a.', ...CYRILLIC_NUMBERED_LIST_TRIGGERS];

const matchListTagByString = (string) => {
  const lowerCasePrefix = string.toLowerCase();

  if (BULLET_LIST_TRIGGERS.includes(lowerCasePrefix)) {
    return LIST_ELEMENTS[0];
  }

  if (NUMBERED_LIST_TRIGGERS.includes(lowerCasePrefix)) {
    return LIST_ELEMENTS[1];
  }

  return null;
};

export default matchListTagByString;
